export { default as IndexTableCellUserAvatar } from './IndexTableCellUserAvatar';
